import React from 'react';

import { flagStyles } from '../settings';

const SvgLB = (): JSX.Element => (
  <img
    style={{
      backgroundPosition: '-3000px 0px',
      ...flagStyles
    }}
    alt=""
  />
);

export default SvgLB;
